import { LocationGroup } from "./LocationGroup";

export default LocationGroup;
